import React, { Component } from 'react'
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import $ from 'jquery'
import moment from 'moment'
import 'moment/min/locales'
import {FormattedMessage, injectIntl} from 'react-intl';
import Timezone from '../../commons/timezone/Timezone.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import ValidacionAutomaticaTooltip from '../presupuestoDetallado/ValidacionAutomaticaTooltip.jsx'

// Estilos para columnas de tabla de presupuesto
const presupuestoColStyle = {
	textAlign: 'left',
	paddingLeft: '8px',
	paddingRight: '8px',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	minWidth: '80px',
	maxWidth: '180px',
};

class TicketVerPresupuestosDetallado extends Component {
	constructor(props) {
		super(props);
		this.props = props;

		this.ajaxHandler = new AjaxHandler();

		moment.locale('es');

		if(props.ticket) {
			this.ticket = props.ticket;
		}
		this.action = props.action;

		this.state = {
			loading: false,
			presupuestos: [],
			indicesDetallesAbiertos: [],
			presupuestoPendiente: null,
			marcaObligatorio: true,
			mecanicosTareasExpandidos: {}
		}
    }

	formatMonto(numero) {
		// Redondear a 2 decimales
		const redondeado = Math.round(numero * 100) / 100;
		// Separar parte entera y decimal
		const partes = redondeado.toFixed(2).split('.');
		// Agregar separador de miles (punto)
		partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
		// Unir con coma como separador decimal
		return partes.join(',');
	}

  componentDidMount() {
		if(Security.hasPermission('TICKETS_VER_PRESUPUESTOS')) {
			this.ajaxHandler.subscribe(this);
			this.loadFormData();
		} else {
			this.setState({
			redirectTo: '/error'
			});
		}
  }

  componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
  }

  componentDidUpdate() {
		$('[data-tooltip="tooltip"]').tooltip();
  }

  loadFormData() {
		let component = this;
		component.setState({ loading: true });
		const marcaObligatorio = ConfigBusiness.get('inventario.marcas.obligatorio') === "false" ? false : true;
		component.setState({ marcaObligatorio });
		component.ajaxHandler.getJson('/ticket-presupuestos/ticket/' + this.props.ticket.id + '/grid')
		.then(data => {
			if(data){
				let index = data.findIndex((element) =>
					element.estado && (
						element.estado.toLowerCase().includes('pendiente') ||
						element.estado.toLowerCase().includes('validado-auditor')
					)
				);
				let presupuestoPendiente = index !== -1 ? data[index] : null;
				component.setState({presupuestos: data, presupuestoPendiente: presupuestoPendiente});
			}
		}).finally(() => {
			component.setState({ loading: false });
		});
  }

  handleViewAdjunto(e, adjunto) {
		this.ajaxHandler.fetch('/ticket-presupuestos/adjunto/' + adjunto, {
			method: 'GET'
		}).then(response => {
			if (response.status === 200) {
			return response.blob();
			}
		}).then(fileBlob => {
			let fileUrl = URL.createObjectURL(fileBlob);
			window.open(fileUrl);
		}).catch(() => {
		});
		e.preventDefault();
  }

	toggleMecanicosTarea(presupuestoIndex, tareaIndex) {
		var clave = presupuestoIndex + '-' + tareaIndex;
		var expandidos = Object.assign({}, this.state.mecanicosTareasExpandidos);
		expandidos[clave] = !expandidos[clave];
		this.setState({ mecanicosTareasExpandidos: expandidos });
	}

	viewDetalle(e, index){
		const indicesAbiertos = [...this.state.indicesDetallesAbiertos];
		const indexPosicion = indicesAbiertos.indexOf(index);

		if(indexPosicion !== -1){
			// Si ya está abierto, lo cerramos
			indicesAbiertos.splice(indexPosicion, 1);
		}else{
			// Si está cerrado, lo abrimos
			indicesAbiertos.push(index);
		}

		this.setState({indicesDetallesAbiertos: indicesAbiertos});
		e.preventDefault();
	}

    renderTableTheadTarea(field, index){
		switch (field) {
			case 'index':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Items" defaultMessage="Items" />
					</th>
				);
			case 'id':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Id" defaultMessage="Id" />
					</th>
				);
			case 'external_code':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Tarea" defaultMessage="Tarea" />
					</th>
				);
			case 'nombre':
				return (
					<th key={index} scope="col" style={presupuestoColStyle}>
						<FormattedMessage id="Presupuesto.Descripción" defaultMessage="Descripción" />
					</th>
				);
			case 'detalle':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Detalle" defaultMessage="Detalle" />
					</th>
				);
			case 'cuenta_mayor':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Cuenta_Mayor" defaultMessage="Cuenta Mayor" />
					</th>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Descripción_Cuenta_Mayor" defaultMessage="Descripción Cuenta Mayor" />
					</th>
				);
			case 'cantidad':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Cantidad" defaultMessage="Cantidad" />
					</th>
				);
			case 'precio':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Precio" defaultMessage="Precio" />
					</th>
				);
			case 'total':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Total" defaultMessage="Total" />
					</th>
				);
			case 'mecanico':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Mecanico" defaultMessage="Mecánico" />
					</th>
				);
			case 'servicio':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Servicio" defaultMessage="Servicio" />
					</th>
				);
			default:
				return null;
		}
	}

    renderTableTheadItem(field, index){
		switch (field) {
			case 'index':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Items" defaultMessage="Items" />
					</th>
				);
			case 'id':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Id" defaultMessage="Id" />
					</th>
				);
			case 'external_code':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Tarea" defaultMessage="Tarea" />
					</th>
				);
			case 'descripcion':
				return (
					<th key={index} scope="col" style={presupuestoColStyle}>
						<FormattedMessage id="Presupuesto.Descripción" defaultMessage="Descripción" />
					</th>
				);
			case 'clasificacion':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Clasificación" defaultMessage="Clasificación" />
					</th>
				);
			case 'detalle':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Detalle" defaultMessage="Detalle" />
					</th>
				);
			case 'cuenta_mayor':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Cuenta_Mayor" defaultMessage="Cuenta Mayor" />
					</th>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Descripción_Cuenta_Mayor" defaultMessage="Descripción Cuenta Mayor" />
					</th>
				);
			case 'cantidad':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Cantidad" defaultMessage="Cantidad" />
					</th>
				);
			case 'costo':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Precio" defaultMessage="Precio" />
					</th>
				);
            case 'marcaNombre':
                return (
                    <th key={index} scope="col" style={presupuestoColStyle} >
                        <FormattedMessage id="Presupuesto.Marca" defaultMessage="Marca" />
                    </th>
                );
			case 'marca':
				return !this.state.marcaObligatorio ? (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Marca" defaultMessage="Marca" />
					</th>
				) : '';
			case 'total':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Total" defaultMessage="Total" />
					</th>
				);
			case 'mecanico':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Mecanico" defaultMessage="Mecánico" />
					</th>
				);
			case 'servicio':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Servicio" defaultMessage="Servicio" />
					</th>
				);
			default:
				return null;
		}
	}

    renderTableTbodyTarea(element, field, index, index_2, presupuestoIndex){
		switch (field) {
			case 'index':
				return (
					<td key={index} className="all custom-lineHeight">
						{(index_2 ? index_2 : index) + 1}
					</td>
				);
			case 'id':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.id_tarea}
					</td>
				);
			case 'external_code':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.external_code}
					</td>
				);
			case 'nombre':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.nombre}
					</td>
				);
			case 'detalle':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.detalle}
					</td>
				);
			case 'cuenta_mayor':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cuenta_mayor}
					</td>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cuenta_mayor_descripcion}
					</td>
				);
			case 'cantidad':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cantidad}
					</td>
				);
			case 'precio':
				return (
					<td key={index} className="all custom-lineHeight">
						{this.formatMonto(element.precio)}
					</td>
				);
			case 'mecanico': {
				var mecanicos = element.mecanicos || [];
				if (mecanicos.length === 0) {
					return <td key={index} className="all custom-lineHeight"></td>;
				}
				if (mecanicos.length === 1) {
					return (
						<td key={index} className="all custom-lineHeight">
							{mecanicos[0].nombre + ' ' + mecanicos[0].apellido}
						</td>
					);
				}
				var clave = presupuestoIndex + '-' + index;
				var expandido = this.state.mecanicosTareasExpandidos[clave] || false;
				return (
					<td key={index} className="all custom-lineHeight">
						<span>{mecanicos[0].nombre + ' ' + mecanicos[0].apellido}</span>
						<button
							className="btn btn-link btn-sm p-0 ml-1"
							style={{verticalAlign: 'baseline'}}
							onClick={() => this.toggleMecanicosTarea(presupuestoIndex, index)}
						>
							<i className={expandido ? 'fa fa-chevron-up fa-xs' : 'fa fa-chevron-down fa-xs'}></i>
							{' +' + (mecanicos.length - 1)}
						</button>
						{expandido && (
							<ul className="list-unstyled mb-0 mt-1" style={{fontSize: '0.9em'}}>
								{mecanicos.slice(1).map(function(m, i) {
									return <li key={i}>{m.nombre + ' ' + m.apellido}</li>;
								})}
							</ul>
						)}
					</td>
				);
			}
			case 'total':
				return (
					<td key={index} className="all custom-lineHeight">
                        {element.precio && element.cantidad ? ('$ ' + this.formatMonto(element.precio*element.cantidad)) : ''}
					</td>
				);
			case 'servicio':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.servicio_nombre}
						<ValidacionAutomaticaTooltip element={element} intl={this.props.intl} />
					</td>
				);
			default:
				return null;
		}
	}

    renderTableTbodyItem(element, field, index, index_2, presupuestoIndex){
		switch (field) {
			case 'index':
				return (
					<td key={index} className="all custom-lineHeight">
						{(index_2 ? index_2 : index) + 1}
					</td>
				);
			case 'id':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.id_item}
					</td>
				);
			case 'external_code':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.external_code}
					</td>
				);
			case 'descripcion':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.descripcion}
					</td>
				);
			case 'clasificacion':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.clasificacion || ''}
					</td>
				);
			case 'detalle':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.detalle}
					</td>
				);
			case 'cuenta_mayor':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cuenta_mayor}
					</td>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cuenta_mayor_descripcion}
					</td>
				);
			case 'cantidad':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cantidad}
					</td>
				);
			case 'costo':
				return (
					<td key={index} className="all custom-lineHeight">
						{this.formatMonto(element.precio)}
					</td>
				);
            case 'marcaNombre':
                return (
                    <td key={index} className="all custom-lineHeight">
                        {element.marcaNombre}
                    </td>
                );
			case 'marca':
				return !this.state.marcaObligatorio ? (
					<td key={index} className="all custom-lineHeight">
						{element.marca ? element.marca : ''}
					</td>
				) : '';
			case 'total':
				return (
					<td key={index} className="all custom-lineHeight">
                        {element.precio && element.cantidad ? ('$ ' + this.formatMonto(element.precio*element.cantidad)) : ''}
					</td>
				);
			case 'mecanico': {
				var mecanicosItem = element.mecanicos || [];
				if (mecanicosItem.length === 0) {
					return <td key={index} className="all custom-lineHeight"></td>;
				}
				if (mecanicosItem.length === 1) {
					return (
						<td key={index} className="all custom-lineHeight">
							{mecanicosItem[0].nombre + ' ' + mecanicosItem[0].apellido}
						</td>
					);
				}
				var claveItem = presupuestoIndex + '-item-' + index;
				var expandidoItem = this.state.mecanicosTareasExpandidos[claveItem] || false;
				return (
					<td key={index} className="all custom-lineHeight">
						<span>{mecanicosItem[0].nombre + ' ' + mecanicosItem[0].apellido}</span>
						<button
							className="btn btn-link btn-sm p-0 ml-1"
							style={{verticalAlign: 'baseline'}}
							onClick={() => this.toggleMecanicosTarea(presupuestoIndex + '-item', index)}
						>
							<i className={expandidoItem ? 'fa fa-chevron-up fa-xs' : 'fa fa-chevron-down fa-xs'}></i>
							{' +' + (mecanicosItem.length - 1)}
						</button>
						{expandidoItem && (
							<ul className="list-unstyled mb-0 mt-1" style={{fontSize: '0.9em'}}>
								{mecanicosItem.slice(1).map(function(m, i) {
									return <li key={i}>{m.nombre + ' ' + m.apellido}</li>;
								})}
							</ul>
						)}
					</td>
				);
			}
			case 'servicio':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.servicio_nombre}
						<ValidacionAutomaticaTooltip element={element} intl={this.props.intl} />
					</td>
				);
			default:
				return null;
		}
	}

	render() {
        let showItems = ConfigBusiness.get('tickets.presupuesto.items.show').split(',');
		let showTareas = ConfigBusiness.get('tickets.presupuesto.tareas.show').split(',');
		let trabajaConManoDeObra = ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true';
		var showItemsSinMecanico = showItems.filter(function(f) { return f !== 'mecanico'; });
		if(this.props.ticket) {
			return (
			<React.Fragment>
				{this.state.loading && <Loading />}
				<div className="row-12">
					{this.state.presupuestos ? (
					<>
						<div className="row pt-4 justify-content-center">
							<div className="col-12 col-md-5">
								<div className="card text-dark" style={{borderLeftWidth: "0px", background: "#eaecef", height: "100%"}}>
									<div className="card-body">
										<div className="text-center">
											<h5 className="card-title mb-3">
												<FormattedMessage id="Presupuesto.Presupuestos_aprobados" defaultMessage="Presupuestos aprobados"/>
											</h5>
											<p className="card-text" style={{fontSize: "32px", color: "#44c8cf"}}>
												<b>${this.formatMonto(this.state.presupuestos
													.filter(presupuesto => presupuesto.estado && presupuesto.estado.toLowerCase().includes('aprobado') && presupuesto.activo === true)
													.reduce((total, presupuesto) => {
														return total + (presupuesto.manoDeObra || 0) + (presupuesto.repuestos || 0) + (presupuesto.impuestos || 0) + (presupuesto.otros || 0);
													}, 0))}</b>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-5">
								<div className="card text-dark" style={{borderLeftWidth: "0px", background: "#eaecef", height: "100%"}}>
									<div className="card-body">
										<div className="text-center">
											<h5 className="card-title mb-3">
												<FormattedMessage id="Presupuesto.Pendiente_de_aprobacion" defaultMessage="Pendiente de aprobación"/>
											</h5>
											<p className="card-text" style={{fontSize: "32px", color: "#ffa726"}}>
												<b>${this.state.presupuestoPendiente ?
													this.formatMonto(this.state.presupuestoPendiente.manoDeObra + this.state.presupuestoPendiente.repuestos + this.state.presupuestoPendiente.impuestos + this.state.presupuestoPendiente.otros)
													: this.formatMonto(0)
												}</b>
											</p>
											{this.state.presupuestoPendiente && (
												<p className="card-text text-muted" style={{fontSize: "14px"}}>
													<FormattedMessage id="Presupuesto.Fecha" defaultMessage="Fecha"/>: <b>{Timezone.getDateForClient(this.state.presupuestoPendiente.fechaHora, 'YYYY-MM-DD HH:mm:ss', "DD/MM/YYYY HH:mm:ss")}</b>
												</p>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</> ): ''}
					<div className="row pt-5">
						<div className="col-md-12">
							<div className="col-md-12">
								<h2 className="p-2" style={{color: "#44c8cf"}}><b><FormattedMessage id="Historial_de_Presupuestos" defaultMessage="Historial de Presupuestos"/></b></h2>
								<table className="table">
									<thead className="thead-fleet">
										<tr>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Fecha" defaultMessage="Fecha"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Nombre" defaultMessage="Nombre"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Subido_por" defaultMessage="Subido por"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Mano_de_obra" defaultMessage="Mano de obra"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Repuestos" defaultMessage="Repuestos"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Impuestos" defaultMessage="Impuestos"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Otros" defaultMessage="Otros"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Total" defaultMessage="Total"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Adicional" defaultMessage="Adicional"/>
											</th>
											{
											ConfigBusiness.get('tickets.trabajaConEstadosPresupuesto.habilitado') === 'true' ?
												<th scope="col" style={presupuestoColStyle} ><FormattedMessage id="Estado" defaultMessage="Estado"/></th>
												: null
											}
											<th className="text-right" scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Acciones" defaultMessage="Acciones"/>
											</th>
										</tr>
									</thead>
									<tbody>
										{this.state.presupuestos.length > 0 ?
											this.state.presupuestos.map((presupuesto, index) => {
												return (
													<React.Fragment key={index}>
														<tr>
															<td className="align-middle">
																{Timezone.getDateForClient(presupuesto.fechaHora, 'YYYY-MM-DD HH:mm:ss', "DD/MM/YYYY HH:mm:ss")}
															</td>
															<td className="align-middle">
																{presupuesto.nombre}
															</td>
															<td className="align-middle">
																{presupuesto.persona.nombre + ' '  + presupuesto.persona.apellido }
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.manoDeObra)}
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.repuestos)}
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.impuestos)}
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.otros)}
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.manoDeObra + presupuesto.repuestos + presupuesto.impuestos + presupuesto.otros)}
															</td>
															<td className="align-middle">
																{presupuesto.adicional? (<div className="text-center success dt-info-icon"><i className="ft-check"></i></div>) : ''}
															</td>
															{ConfigBusiness.get('tickets.trabajaConEstadosPresupuesto.habilitado') === 'true' ?
																<td className="align-middle">
																{
																	presupuesto.estado && (
																		<span className={
																			{
																				'Pendiente': 'pendiente',
																				'Pendiente-Auditor': 'pendiente',
																				'Validado-Auditor': 'pendiente',
																				'Rechazado': 'rechazado-presupuesto-color',
																				'Aprobado': 'aprobado-presupuesto-color',
																				'Auto-Aprobado': 'aprobado-presupuesto-color',
																			}[presupuesto.estado] || ''
																		}>
																			<FormattedMessage id={presupuesto.estado} defaultMessage={presupuesto.estado} />
																		</span>
																	)
																}
																</td>
															: null}
															<td className="text-right">
																<div className="d-inline-flex">
																	<button
																		className="action view btn btn-sm btn-icon btn-dt-grid text-fleet"
																		title="Ver"
																		data-togle="tooltip"
																		data-placement="top"
																		onClick={(e) => this.viewDetalle(e, index)}
																	>
																		<i className="fa fa-eye fa-xs"/>
																	</button>
                                                                    {presupuesto.adjunto ?
                                                                        <button
                                                                            className="action btn btn-icon text-fleet btn-sm btn-dt-grid p-0 m-0"
                                                                            data-tooltip="tooltip"
                                                                            data-placement="top"
                                                                            title={this.props.intl.formatMessage({ id: 'Ver_Adjunto', defaultMessage: 'Ver Adjunto' })}
                                                                            onClick={(e) => this.handleViewAdjunto(e, presupuesto.adjunto)}
                                                                        >
                                                                            <i className="fa fa-paperclip fa-xs"></i>
                                                                        </button>
                                                                    : null}
																</div>
															</td>
														</tr>
														{
															this.state.indicesDetallesAbiertos.includes(index) ?
															<tr style={{background: "#eaecef"}}>
																<td colSpan="10">
																	<div className="p-2">
																		<div className="col-md-12">
																			<div className="col-md-12">
																				<h2 className="p-2" style={{color: "#44c8cf"}}><b><FormattedMessage id="Mano_de_Obra" defaultMessage="Mano de Obra"/></b></h2>
																				<table className="table">
																					<thead className="thead-fleet">
																						<tr>
																							{trabajaConManoDeObra
																								? showItems.map(function(field, idx) { return this.renderTableTheadItem(field, idx); }.bind(this))
																								: showTareas.map(function(field, idx) { return this.renderTableTheadTarea(field, idx); }.bind(this))
																							}
																						</tr>
																					</thead>
																					<tbody>
																						{trabajaConManoDeObra
																							? presupuesto.presupuestoRepuestos.filter(function(el) { return el.tipo === 'Mano De Obra'; }).map(function(element, idx) {
																								return (
																									<tr key={idx}>
																										{showItems.map(function(field) { return this.renderTableTbodyItem(element, field, idx, null, index); }.bind(this))}
																									</tr>
																								);
																							}.bind(this))
																							: presupuesto.presupuestoManoObras.map(function(element, idx) {
																								return (
																									<tr key={idx}>
																										{showTareas.map(function(field) { return this.renderTableTbodyTarea(element, field, idx, null, index); }.bind(this))}
																									</tr>
																								);
																							}.bind(this))
																						}
																						<tr>
																							<td className="align-middle" colSpan="2">
																								<b style={{fontSize: "17px"}}><FormattedMessage id="Presupuesto.Total_Mano_de_Obra" defaultMessage="Total Mano de Obra"/></b>
																							</td>
																							<td className="align-middle" colSpan={trabajaConManoDeObra ? showItems.length - 3 : showTareas.length - 3}>
																							</td>
																							<td className="align-middle">
																								<b style={{fontSize: "17px"}}>$ {this.formatMonto(presupuesto.manoDeObra)}</b>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</div>
																		</div>
																	</div>
																	<div className="p-2">
																		<div className="col-md-12">
																			<div className="col-md-12">
																				<h2 className="p-2" style={{color: "#44c8cf"}}><b><FormattedMessage id="Repuestos" defaultMessage="Repuestos"/></b></h2>
																				<table className="table">
																					<thead className="thead-fleet">
																						<tr>
																							{showItemsSinMecanico.map(function(field, idx) { return this.renderTableTheadItem(field, idx); }.bind(this))}
																						</tr>
																					</thead>
																					<tbody>
																						{(trabajaConManoDeObra
																							? presupuesto.presupuestoRepuestos.filter(function(el) { return el.tipo !== 'Mano De Obra'; })
																							: presupuesto.presupuestoRepuestos
																						).map(function(element, idx) {
																							return (
																								<tr key={idx}>
																									{showItemsSinMecanico.map(function(field) { return this.renderTableTbodyItem(element, field, idx, null); }.bind(this))}
																								</tr>
																							);
																						}.bind(this))}
																						<tr>
																							<td className="align-middle" colSpan="2">
																								<b style={{fontSize: "17px"}}><FormattedMessage id="Presupuesto.Total_Repuestos" defaultMessage="Total Repuestos"/></b>
																							</td>
																							<td className="align-middle" colSpan={showItemsSinMecanico.length - 3}>
																							</td>
																							<td className="align-middle">
																								<b style={{fontSize: "17px"}}>$ {this.formatMonto(presupuesto.repuestos)}</b>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</div>
																		</div>
																	</div>
																</td>
															</tr>
															: null
														}
													</React.Fragment>)
										})
									:
										<tr>
											<td colSpan="10" align={"center"}>
												<FormattedMessage
													id="No_hay_datos_disponibles"
													defaultMessage="No hay datos disponibles"
												/>
											</td>
										</tr>
									}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
			)
		} else {
			return null;
		}
  }
}

export default injectIntl(TicketVerPresupuestosDetallado);
